
import ConfigScene from '../../helpers/ConfigScene';

class BgSky extends PIXI.Container {
  constructor() {
    super();

    // parts
    this.bg0 = null;
    this.bg1 = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // parts
    this.bg0 = new PIXI.Sprite.fromImage(aScene.imgPool['lr-bg-0']);
    this.addChild(this.bg0);
    this.bg1 = new PIXI.Sprite.fromImage(aScene.imgPool['lr-bg-1']);
    this.bg1.y = this.bg0.height;
    this.addChild(this.bg1);

    // loop
    aScene.signals.loopCall.add(this.loopUp, this);
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    this.x = ConfigScene.MOVE_DIFF_SKY.X * aScene.iManager.stageRatio.half.x;
    this.y = ConfigScene.MOVE_DIFF_SKY.Y * aScene.iManager.stageRatio.half.y;
  }
}

export default BgSky;



// WEBPACK FOOTER //
// ./src/js/scene/parts/components/BgSky.js